import React, { useEffect, useState } from "react";
import { Form, Input, Button, Tag, Space } from "antd";

const PickList = ({ form, error, setError }) => {
  const [tags, setTags] = useState([]);

  const addTag = () => {
    setError(false);
    form.validateFields(["newTag"]).then(() => {
      const value = form.getFieldValue("newTag")?.trim();
      if (value && !tags?.includes(value)) {
        const updatedTags = [...(tags || []), value];
        setTags(updatedTags);
        form.setFieldsValue({ pickValues: updatedTags });
        form.resetFields(["newTag"]);
      }
    });
  };
  const options = form.getFieldValue("pickValues");

  useEffect(() => {
    setTags(options?.map((d) => (d.value ? d?.value : d)));
  }, [options]);

  const removeTag = (removedTag) => {
    const updatedTags = tags.filter((tag) => tag !== removedTag);
    setTags(updatedTags);
    form.setFieldsValue({ pickValues: updatedTags });
  };

  return (
    <>
      <Form.Item style={{ marginBottom: 0 }} name="pickValues" hidden>
        <Input className="common-input" />
      </Form.Item>

      <Form.Item
        style={{ marginBottom: 0 }}
        label={
          <label className="form-label heading15px">
            <span className="text-required">*</span>PickList Values
          </label>
        }
        name="newTag"
      >
        <Space.Compact style={{ width: "100%" }}>
          <Input
            style={{
              padding: "11px",
              border: error ? "1px solid #ff4d4f" : "",
            }}
            className="common-input"
            placeholder="Enter PickList Value"
          />
          <Button type="primary" className="theme-btn" onClick={addTag}>
            Add
          </Button>
        </Space.Compact>
      </Form.Item>

      {tags?.length > 0 && (
        <Form.Item style={{ marginBottom: 0, marginTop: 10 }}>
          <Space wrap>
            {tags.map((tag) => (
              <Tag
                closable
                key={tag}
                onClose={() => removeTag(tag)}
                style={{ fontSize: "13px", padding: "4px 8px" }}
              >
                {tag}
              </Tag>
            ))}
          </Space>
        </Form.Item>
      )}
    </>
  );
};

export default PickList;
